import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {AuthService} from "./auth.service";

export interface CartItem {
    id: number;
    name: string;
    price: number;
    price1: number;
    price5: number;
    price12: number;
    price25: number;
    price50: number;
    price100: number;
    price200: number;
    image: string[];
    quantity: number;
    deliveryCharge: number;
}

@Injectable({
    providedIn: 'root'
})
export class CartService {

    private cartItems: CartItem[] = [];

    private cartSubject = new BehaviorSubject<CartItem[]>([]);
    cart$ = this.cartSubject.asObservable();

    private cartCountSubject = new BehaviorSubject<number>(0);
    cartCount$ = this.cartCountSubject.asObservable();

    private baseUrl = environment.API_BASE_URL;

    constructor(private http: HttpClient, private authService: AuthService) {

        // Load cart from localStorage on service initialization
        const savedCart = localStorage.getItem('cart');

        if (savedCart) {
            this.cartItems = JSON.parse(savedCart);
        }

        this.updateCartState();
    }

    private updateCartState() {

        // Save cart to localStorage
        localStorage.setItem('cart', JSON.stringify(this.cartItems));

        // Update cart observable
        this.cartSubject.next(this.cartItems);

        // Update cart count
        const totalQuantity = this.cartItems.reduce(
            (total, item) => total + item.quantity,
            0
        );

        this.cartCountSubject.next(totalQuantity);
    }

    addToCart(item: {
        id: number;
        name: string;
        price: number;
        price1: number;
        price5: number;
        price12: number;
        price25: number;
        price50: number;
        price100: number;
        price200: number;
        image: string[];
        quantity: number;
        deliveryCharge: number
    }): boolean {

        const existing = this.cartItems.find(p => p.id === item.id);

        if (existing) {
            existing.quantity += item.quantity;
            this.updateCartState();
            return false; // already existed
        } else {
            this.cartItems.push(item);
            this.updateCartState();
            return true; // new item
        }
    }

    removeFromCart(id: number) {
        this.cartItems = this.cartItems.filter(item => item.id !== id);
        this.updateCartState();
    }

    updateQuantity(id: number, quantity: number) {
        const item = this.cartItems.find(p => p.id === id);
        if (item) {
            item.quantity = quantity;
        }
        this.updateCartState();
    }

    clearCart() {
        this.cartItems = [];
        this.updateCartState();
    }

    getCartItems() {
        return this.cartItems;
    }

    createOrder(orderData: any) {

        return this.http.post(this.baseUrl + '/api/orders/create', orderData);
    }

    verifyPayment(paymentData: any) {
        return this.http.post(this.baseUrl + '/api/orders/verify', paymentData);
    }

}